import * as React from 'react';
import { prefix } from "../../wui-core/src/index.js";

var defaultEmpty = function defaultEmpty() {
  return /*#__PURE__*/React.createElement("img", {
    className: "".concat(prefix, "-empty-image-defaultImage")
  });
};

export default defaultEmpty;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-empty/src/defaultEmpty.js